export const getEnvConfig = (): Record<string, string | undefined> => {
  return process.env;
};
